<p-dialog
  header="Download from EFS"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '500px', minWidth: '300px' }"
  [closeOnEscape]="false"
>
  <label for="date">EFS Transactions end date</label> <br />
  <input
    type="date"
    autocomplete="off"
    [(ngModel)]="date"
    [attr.aria-label]="date"
    class="form-control"
    id="date"
  />

  <p-footer>
    <button type="button" class="btn btn-secondary mr-3" (click)="closeModal()">Close</button>
    <button type="button" class="btn btn-primary" (click)="import()">Import</button>
  </p-footer>
</p-dialog>
